<template>
    <Head>
        <title>Eventos {{ title }}</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-noticias.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Eventos {{ title }}</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-general">
        <div class="container">

            <div class="slider-tramites-servicios__encabezado row pr-0 flex">
                <div class="col-lg-8 col-md-6">
                    Estas viendo los Eventos {{ title }}
                </div>
                <div class="col-lg-4 col-md-6 text-right" v-if="title=='Próximos'">
                    <Link href="/eventos-pasados" class="boton-principal" preserve-scroll><i class="fi fi-history"></i> Ver Eventos Pasados</Link>
                </div>
                <div class="col-lg-4 col-md-6 text-right" v-if="title=='Pasados'">
                    <Link href="/eventos" class="boton-principal boton-flecha" preserve-scroll> Ver Eventos Próximos</Link>
                </div>
            </div>

            <div class="row">
                <EventoBox :item="item" v-for="(item, index) in eventos.data" :key="index" class="col-md-6 col-lg-4" />
            </div>

            <div class="row" v-if="eventos.total > limit">
                <div class="col-12">
                    <Paginacion :links="eventos.links"/>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import EventoBox from '../../Shared/Eventos/EventoBox.vue'
import Paginacion from '../../Shared/Paginacion.vue'
import { Link } from '@inertiajs/inertia-vue3'

export default {
    props: {
        eventos: Object,
        limit: Number,
        title: String,
    },
    components: { Paginacion, EventoBox, Link }
}
</script>
<style scoped>
    .flex{
        display: flex;
        align-items: center;
    }
</style>
